import { selectedConfigurationSchema } from "@/lib/schema/configuration/configuration";
import z from "zod";



export const editSurveySchema = z.object({
    name: z.string({ required_error: 'Name is required' }),
    description: z.string({ required_error: "Description is required" }),
    crm_config_id: z.number().optional().nullable(),
    selected_configuration: selectedConfigurationSchema.optional().nullable(),
});
